import css from './aio.less';
import type {ComposedFC,ClassValue} from '../../helpers/react-helpers'
import cn from 'classnames'
import AioRequiredAsterisk from './AioRequiredAsterisk'

/**
 * This label is absolutely positioned. It is meant to be used inside an input wrapper.
 */
const AioLabel: ComposedFC<'label',{required?:boolean,className?:ClassValue}> = ({children,className,required,...props}) => (
    <label className={cn(css.label,className)} {...props}>{children}{required ? <AioRequiredAsterisk/> : null}</label>
)
export default AioLabel


export const AioInlineLabel: ComposedFC<'label',{required?:boolean,className?:ClassValue}> = ({children,className,required,...props}) => (
    <label className={cn(css.inlineLabel,className)} {...props}>{children}{required ? <AioRequiredAsterisk/> : null}</label>
)
